<template>
	<div class="order-body">
		<div class="fx-header">
			<p>批量代客下单</p>
		</div>
		<div class="valet-content-body">
			<valetCInfo @changeCus='changeCus' @setValue='getValue' @setSyscodeid='setSyscodeid' @setAddress='setAddress' :shopId='shopId' ref="topPart"/>
			<MainTable :acountValue='acountValue' :bigClassList='bigClassList' :shopId='shopId' :organid='organid'
			:buyersyscodeid='buyersyscodeid' :address='address' :addressType='addressType' :orderNumberRoundRules='orderNumberRoundRules' :orderdecimalcount='orderdecimalcount' ref="midPart"/>
			<memoInfo :acountValue='acountValue' ref="bottomPart"/>
		</div>
		<div class="valet-foot">
			<el-button class="btn" plain type="primary" size='small' @click="goOrder">取消</el-button>
            <el-button class="btn" plain type="primary" size='small' @click="submit">提交</el-button>
		</div>
		<el-dialog title="提示" class="dialog-title1" :visible.sync="tipModal" width='400px' :close-on-click-modal="false">
			<div style="margin-bottom:10px;font-size:15px">提交的商品单价与客户专有价格不同！</div>
			<div style="padding-bottom:10px" v-for="item in tipData" :key="item">
				{{item}}
			</div>
			<div style="font-size:15px">是否继续？</div>
			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="noSubmit">取 消</el-button>
				<el-button size="small" type="primary" @click="submitAgain">确 定</el-button>
			</span>
		</el-dialog>
		<el-dialog title="信用额度不足,无法提单！" class="dialog-title2" :visible.sync="advanceModal" width='400px' :close-on-click-modal="false">
			<div style="font-size:18px;text-align:center">请买家客户支付订单后,再提单！</div>
			<span slot="footer" class="dialog-footer">
				<el-button size="small" type="primary" @click="checkDetail">查看未支付订单</el-button>
			</span>
		</el-dialog>
		<el-dialog title="信用额度使用明细" class="dialog-title3" :visible.sync="detailModal" width='800px' :close-on-click-modal="false">
			<div style="margin-bottom:10px;font-size:15px">以下订单使用信用额度,但未支付单据:</div>
			<div class="main-table-box">
				<el-table
					class="grid-content"
					:data="detailData"
					border
					stripe
					height="400"
				>
					<el-table-column
						label-class-name="column-index"
						label="序号"
						type="index"
						width="50"
						align="center">
					</el-table-column>
					<el-table-column
						prop="ordernumber"
						label="订单编号"
						align="center">
					</el-table-column>
					<el-table-column
						prop="shopname"
						label="销售店铺"
						align="center">
					</el-table-column>
					<el-table-column
						prop="money"
						label="订单占用信用额度"
						align="center">
						<template slot-scope="scope">
							<div>￥{{scope.row.money}}</div>
						</template>
					</el-table-column>
					<el-table-column
						prop="disabledflag"
						label="订单状态"
						align="center">
						<template slot-scope="scope">
							<div v-if="scope.row.billState === 0">待付款</div>
							<div v-if="scope.row.billState === 1">待接单</div>
							<div v-if="scope.row.billState === 2">待发货</div>
							<div v-if="scope.row.billState === 3">待收货</div>
							<div v-if="scope.row.billState === 4">已完成</div>
							<div v-if="scope.row.billState === 5">备货中</div>
						</template>
					</el-table-column>
					<el-table-column label="操作" align="center">
						<template slot-scope="scope">
							<el-button type='text' size="mini" @click="goDetail(scope.row)">查看</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="detailClose">取 消</el-button>
				<el-button size="small" type="primary" @click="detailClose">确 定</el-button>
			</span>
		</el-dialog>
		<el-dialog title="无法提单！" class="dialog-title2" :visible.sync="advanceModal2" width='400px' :close-on-click-modal="false">
			<div style="font-size:18px;text-align:center">请买家客户支付订单后,再提单！</div>
			<span slot="footer" class="dialog-footer">
				<el-button size="small" type="primary" @click="checkDetail2">查看未支付订单</el-button>
			</span>
		</el-dialog>
		<el-dialog title="未支付订单明细" class="dialog-title3" :visible.sync="detailModal2" width='800px' :close-on-click-modal="false">
			<div class="main-table-box">
				<el-table
					class="grid-content"
					:data="detailData2"
					border
					stripe
					height="400"
				>
					<el-table-column
						label-class-name="column-index"
						label="序号"
						type="index"
						width="50"
						align="center">
					</el-table-column>
					<el-table-column
						prop="ordernumber"
						label="订单编号"
						align="center">
						<template slot-scope="scope">
							<div>{{scope.row.ordernumber}}<i class="el-icon-document-copy icon-copy"
							v-clipboard:copy="scope.row.ordernumber"
							v-clipboard:success="onCodeCopy"
							v-clipboard:error="onCodeError"/></div>
						</template>
					</el-table-column>
					<el-table-column
						prop="shopname"
						label="销售店铺"
						align="center">
					</el-table-column>
					<el-table-column
						prop="amount"
						label="订单金额"
						align="center">
						<template slot-scope="scope">
							<div>￥{{scope.row.amount}}</div>
						</template>
					</el-table-column>
					<el-table-column
						prop="orderstatus"
						label="订单状态"
						align="center">
						<template slot-scope="scope">
							<div v-if="scope.row.orderstatus === 0">待付款</div>
							<div v-if="scope.row.orderstatus === 1">待接单</div>
							<div v-if="scope.row.orderstatus === 2">待发货</div>
							<div v-if="scope.row.orderstatus === 3">待收货</div>
							<div v-if="scope.row.orderstatus === 4">已完成</div>
							<div v-if="scope.row.orderstatus === 5">备货中</div>
						</template>
					</el-table-column>
					<el-table-column label="操作" align="center">
						<template slot-scope="scope">
							<el-button type='text' size="mini" @click="goDetail2(scope.row)">查看</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="detailClose2">取 消</el-button>
				<el-button size="small" type="primary" @click="detailClose2">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
// import app from '@/main.js'
import valetCInfo from '@/components/batchValetDetail/valetCInfo.vue'
import MainTable from '@/components/batchValetDetail/MainTable.vue'
import memoInfo from '@/components/batchValetDetail/memoInfo.vue'
export default {
	name: 'batchValetDetail',
	components: {
		valetCInfo,
		MainTable,
		memoInfo
	},
	data () {
		return {
			userinventoryflag: false,
			shopOptions: [],
			shopId: '',
			organid: '',
			active: '全部订单',
			dateValue: [this.$fxUtils.getCurrentMonthFirst() + ' 00:00', this.$fxUtils.getCurrentMonthLast() + ' 23:59'],
			buyerTel: '',
			orderNumber: '',
			paymentMode: '-1',
			acceptMode: '-1',
			cancelMode: '-1',
			pushstate: '-1',
			buyerName: '',
			acountValue: '',
			bigClassList: [],
			buyersyscodeid: '',
			addressType: '',
			address: '',
			unpaidInvalidTime: 2,
			dataObj: {},
			checkPriceFlag: 1,
			tipModal: false,
			tipData: [],
			tipId: [],
			advanceModal: false,
			detailModal: false,
			detailData: [],
			advanceModal2: false,
			detailModal2: false,
			detailData2: [],
			AuthorityList: {
				'07_0001_0001_00': false,
				'07_0001_0002_00': false,
				'07_0001_0003_00': false,
				'07_0001_0004_00': false,
				'07_0001_0005_00': false,
				'07_0001_0006_00': false,
				'07_0001_0007_00': false,
				'07_0001_0008_00': false,
				'07_0001_0009_00': false,
				'07_0001_0010_00': false,
				'07_0001_0011_00': false,
				'07_0001_0012_00': false,
				'07_0001_0013_00': false,
				'07_0001_0014_00': false,
				'07_0001_0015_00': false,
				'07_0001_0016_00': false,
				'07_0001_0017_00': false,
				'07_0001_0018_00': false,
				'07_0001_0019_00': false,
				'07_0001_0020_00': false,
				'07_0001_0021_00': false,
				'07_0001_0022_00': false,
				'07_0001_0025_00': false,
				'07_0001_0026_00': false,
				'07_0001_0027_00': false
			},
			id: '',
			orderNumberRoundRules: null,
			orderdecimalcount: null
		}
	},
	created () {
		if (this.$route.query.dataObj !== undefined) {
			this.dataObj = JSON.parse(this.$route.query.dataObj)
		}
		this.id = this.$route.query.id
		this.$fxEventBus.$emit('setMenu', '6-7')
		this.getAuthority('07_0001_0000_00')
		this.openPage()
		this.getSyestem()
	},
	methods: {
		getAuthority (data) {
			let params = {
				pId: data
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList[a[i]] = true
					}
				}
			})
		},
		checkDetail () {
			this.detailModal = true
		},
		detailClose () {
			this.detailModal = false
		},
		checkDetail2 () {
			this.detailModal2 = true
		},
		detailClose2 () {
			this.detailModal2 = false
		},
		changeCus (data) {
			console.log(data)
			this.$refs.midPart.customData = data
			this.$refs.bottomPart.isOffLine = data.isOffLine === 1
		},
		goDetail (row) {
			if ((row.billState === 0 && (this.AuthorityList['07_0001_0002_00'] || this.AuthorityList['07_0001_0003_00'])) || (row.billState === 1 && (this.AuthorityList['07_0001_0005_00'] || this.AuthorityList['07_0001_0006_00'])) || (row.billState === 2 && (this.AuthorityList['07_0001_0008_00'] || this.AuthorityList['07_0001_0009_00'])) || (row.billState === 3 && (this.AuthorityList['07_0001_0014_00'] || this.AuthorityList['07_0001_0015_00'])) || (row.billState === 4 && (this.AuthorityList['07_0001_0017_00'] || this.AuthorityList['07_0001_0018_00'])) || (row.billState === 5 && (this.AuthorityList['07_0001_0020_00'] || this.AuthorityList['07_0001_0021_00']))) {
				let orderParams = {}
				orderParams.orderId = row.orderid
				orderParams.statusId = row.statusId
				orderParams.differ = row.differ
				orderParams.buypullstate = row.buypullstate
				switch (row.billState) {
				case 0:
					orderParams.billState = '待付款'
					break
				case 1:
					orderParams.billState = '待接单'
					break
				case 2:
					orderParams.billState = '待发货'
					break
				case 3:
					orderParams.billState = '待收货'
					break
				case 4:
					orderParams.billState = '已完成'
					break
				case 5:
					orderParams.billState = '已取消'
					break
				}
				window.sessionStorage.setItem('orderInfo', JSON.stringify(orderParams))
				let tabInfo = {}
				tabInfo.active = orderParams.billState
				tabInfo.isSellerpull = false
				tabInfo.orderStatus = row.billState
				window.sessionStorage.setItem('tabInfo', JSON.stringify(tabInfo))
				this.$router.push('/main/orderDetail')
			} else {
				this.$message.error('您没有该订单权限,不可查看该订单！')
			}
		},
		onCodeCopy (e) {
			this.$message.success('复制成功！')
		},
		onCodeError (e) {
			this.$message.error('复制失败！')
		},
		goDetail2 (row) {
			if ((row.orderstatus === 0 && (this.AuthorityList['07_0001_0002_00'] || this.AuthorityList['07_0001_0003_00'])) || (row.orderstatus === 1 && (this.AuthorityList['07_0001_0005_00'] || this.AuthorityList['07_0001_0006_00'])) || (row.orderstatus === 2 && (this.AuthorityList['07_0001_0008_00'] || this.AuthorityList['07_0001_0009_00'])) || (row.orderstatus === 3 && (this.AuthorityList['07_0001_0014_00'] || this.AuthorityList['07_0001_0015_00'])) || (row.orderstatus === 4 && (this.AuthorityList['07_0001_0017_00'] || this.AuthorityList['07_0001_0018_00'])) || (row.orderstatus === 5 && (this.AuthorityList['07_0001_0020_00'] || this.AuthorityList['07_0001_0021_00']))) {
				let orderParams = {}
				orderParams.orderId = row.orderid
				window.sessionStorage.setItem('orderInfo', JSON.stringify(orderParams))
				this.$router.push('/main/orderDetail')
			} else {
				this.$message.error('您没有该订单权限,不可查看该订单！')
			}
		},
		// 系统设置
		getSyestem () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/order/getOrderSystemSetting/`
			}).then(res => {
				if (res.result) {
					this.unpaidInvalidTime = res.data.unpaidInvalidTime
					this.userinventoryflag = res.data.userinventoryflag
					console.log(this.unpaidInvalidTime)
				} else {
					this.$message.error(res.msg)
				}
			}).catch((res) => {
				this.$message.error(res.msg)
			})
		},
		// 修改地址
		setAddress (type, value) {
			console.log(type, value)
			this.addressType = type
			this.address = value
		},
		// 获取大类
		getBigClss () {
			let data = {
				shopId: this.shopId
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/goods/getBigCategory`,
				data: data
			}).then(res => {
				if (res.result) {
					let all = { bc_name: '全部', bc_id: '' }
					res.data.unshift(all)
					this.bigClassList = res.data
				}
			}).catch(error => {
				this.$message.error(error.msg)
			})
		},
		getValue (value) {
			this.acountValue = value
			this.$refs.midPart.tableData = []
			this.$refs.midPart.goodsMoney = '0.00'
			this.$refs.midPart.totalMoney = '0.00'
		},
		setSyscodeid (value) {
			// console.log(value)
			this.buyersyscodeid = value
		},
		openPage () {
			this.findShopList().then((data) => {
				if (data.length > 0) {
					this.shopId = data[0].shopId
					this.organid = data[0].organid
					this.shopOptions = data
					this.getBigClss()
				}
			})
			this.getSystemSetting().then((data) => {
				this.getDetail()
			})
		},
		// 系统设置
		getSystemSetting () {
			return new Promise((resolve, reject) => {
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIV}/shop/order/getOrderSystemSetting`
				}).then(res => {
					this.orderNumberRoundRules = res.data.ordermoneyroundrules
					this.orderdecimalcount = res.data.orderdecimalcount
					resolve()
				})
			})
		},
		// 获取详情
		getDetail () {
			let params = {
				orderId: this.id
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/replaceorder/replaceorderdetail`,
				data: params
			}).then(res => {
				if (res.result) {
					this.orderNumber = res.data.orderNumber
					this.$refs.topPart.ccid = res.data.customercategoryid
					this.$refs.topPart.value = res.data.userid
					this.$refs.topPart.userName = res.data.customername
					this.$refs.topPart.customerid = res.data.customerId
					this.$refs.topPart.syscode = res.data.syscode
					this.$refs.topPart.buyersyscodeid = res.data.buyersyscodeid
					this.$refs.topPart.radio = res.data.addressId || ''
					this.buyersyscodeid = res.data.buyersyscodeid
					let radioArr = [{ name: res.data.buyerName, tel: res.data.buyerTel, addrcopy: res.data.buyerAddress + res.data.buyerAddressDetail, id: res.data.addressId, addr: res.data.buyerAddress, provincename: res.data.provincename, cityname: res.data.cityname, districtname: res.data.districtname }]
					this.$refs.topPart.radioList = radioArr || []
					res.data.detail.forEach(e => {
						e.itemmoney = this.$fxUtils.toFixedSHW(e.itemmoney, 2)
						if (e.commpressflag) {
							if (e.url) {
								e.url = this.$fxUtils.changeImgSrc(e.url, 'big')
							}
						}
						if (e.speprice === 0) {
							e.speprice = e.speprice.toString()
						}
						e.basePrice = e.price
						e.realPrice = e.price
						e.unitType = 0
						e.selected = true
						e.isRed = false
						if (e.useUnitFlag === 1) {
							e.unitType = 1
							let price = e.basePrice * e.assistRatio
							e.realPrice = this.toFix(price)
							if (e.inventory < 0) {
								e.unitInventory = -(this.toFix((-e.inventory) / e.assistRatio))
							} else {
								e.unitInventory = this.toFix(e.inventory / e.assistRatio)
							}
							e.importPrice = e.realPrice
						}
					})
					this.$refs.midPart.tableData = res.data.detail
					// console.log(this.$refs.midPart.tableData)
					this.acountValue = res.data.userid
					this.$refs.midPart.calcGoodsMoney()
					let customData = {
						canpaylaterflag: res.data.canpaylaterflag,
						creditlineflag: res.data.creditlineflag,
						paymodes: res.data.paymodes,
						usablecreditline: res.data.usablecreditline,
						isOffLine: res.data.isOffLine,
						id: res.data.customerId
					}
					this.$refs.midPart.customData = customData
					this.$refs.bottomPart.isOffLine = res.data.isOffLine === 1
					this.$refs.bottomPart.createOrderDate = res.data.createOrderDate
				} else {
					this.$message.error(res.msg)
				}
			}).catch(err => {
				console.log(err)
				this.$message.error(err.msg)
			})
		},
		toFix (price) {
			if (+price === 0) {
				return '0.00'
			}
			let num = isNaN(price) ? 0 : price
			num = +num + 0.0000000001
			num = num + ''
			if (num.indexOf('.') !== -1) {
				num = num.substring(0, num.indexOf('.') + 3)
			}
			return num
		},
		// 取消
		goOrder () {
			this.$router.push('/main/batchValet')
		},
		showTip () {
			return new Promise((resolve, reject) => {
				this.$confirm('是否保存该客户地址？', '提示', {
					confirmButtonText: '确认',
					cancelButtonText: '取消',
					type: 'warning',
					closeOnClickModal: false
				}).then(() => {
					resolve(true)
				}).catch(() => {
					resolve(false)
				})
			})
		},
		saveAddress () {
			let valetCInfo = this.$refs.topPart
			let address = {}
			return new Promise((resolve, reject) => {
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIVShop}/replacorder/saveTemplateAddress`,
					data: this.addressParams
				}).then(res => {
					if (res.result) {
						this.$refs.topPart.defaultRadio = res.data.id
						this.$refs.topPart.errorAddress()
						address = {
							addressid: res.data.id,
							name: res.data.name,
							provincename: JSON.parse(valetCInfo.ruleForm.province).name,
							cityname: JSON.parse(valetCInfo.ruleForm.city).name,
							districtname: res.data.districtname,
							addr: valetCInfo.ruleForm.address.replace(/[\r\n\t]/g, '') + valetCInfo.ruleForm.memo.replace(/[\r\n\t]/g, ''),
							street: valetCInfo.ruleForm.address.replace(/[\r\n\t]/g, ''),
							detailAddr: valetCInfo.ruleForm.memo.replace(/[\r\n\t]/g, ''),
							tel: res.data.tel
						}
						console.log(address)
						this.save(address, false)
					} else {
						this.$message.error(res.msg)
					}
					resolve()
				}).catch(err => {
					this.$message.error(err.msg)
				})
			})
		},
		// 提交订单
		submit () {
			let memoInfo = this.$refs.bottomPart
			let valetCInfo = this.$refs.topPart
			let MainTable = this.$refs.midPart
			let wantarrivaldate = new Date(memoInfo.wantarrivaldate).getTime()
			let currentdate = memoInfo.createOrderDate ? new Date(memoInfo.createOrderDate).getTime() : new Date().getTime()
			if (Boolean(memoInfo.wantarrivaldate) && wantarrivaldate < currentdate) {
				this.$message.error('期望到货时间不能小于下单时间!')
				return false
			}
			if (valetCInfo.value === '' || valetCInfo.value === null) {
				this.$message.error('请选择客户!')
				return false
			}
			if (MainTable.tableData.length === 0) {
				this.$message.error('请添加商品!')
				return false
			}
			for (let i = 0; i < MainTable.tableData.length; i++) {
				let item = MainTable.tableData[i]
				if (+item.realPrice < 0 && !item.giftflag) {
					this.$message.error('当前存在价格为负值的商品，无法提交！')
					return false
				}
			}
			let address = {}
			if (valetCInfo.radio === '0') {
				this.$refs.topPart.$refs['ruleForm'].validate((valid) => {
					if (!valid) {
						this.$message.error('请完善地址信息!')
						return false
					} else {
						this.showTip().then(res => {
							address = {
								area: JSON.parse(valetCInfo.ruleForm.province).areacode,
								district: valetCInfo.ruleForm.district,
								coordinate: valetCInfo.locationLng + ',' + valetCInfo.locationLat,
								province: JSON.parse(valetCInfo.ruleForm.province).id,
								city: JSON.parse(valetCInfo.ruleForm.city).id,
								name: valetCInfo.ruleForm.linkman,
								provincename: JSON.parse(valetCInfo.ruleForm.province).name,
								cityname: JSON.parse(valetCInfo.ruleForm.city).name,
								districtname: valetCInfo.ruleForm.districtname,
								addr: valetCInfo.ruleForm.address.replace(/[\r\n\t]/g, '') + valetCInfo.ruleForm.memo.replace(/[\r\n\t]/g, ''),
								street: valetCInfo.ruleForm.address.replace(/[\r\n\t]/g, ''),
								detailAddr: valetCInfo.ruleForm.memo.replace(/[\r\n\t]/g, ''),
								tel: valetCInfo.ruleForm.tel
							}
							if (res) {
								this.addressParams = {
									address: address,
									buyersyscodeid: valetCInfo.buyersyscodeid,
									userid: valetCInfo.value
								}
								this.saveAddress()
							} else {
								this.save(address, false)
							}
						})
					}
				})
			} else {
				for (let a = 0; a < valetCInfo.radioList.length; a++) {
					if (valetCInfo.radio === valetCInfo.radioList[a].id) {
						let addr = valetCInfo.radioList[a].addr
						let addr1 = ''
						let addr2 = ''
						if (addr.indexOf('{"detail":') !== -1) {
							addr1 = JSON.parse(addr).detail
							addr2 = JSON.parse(addr).local
						}
						address = {
							name: valetCInfo.radioList[a].name,
							provincename: valetCInfo.radioList[a].provincename,
							cityname: valetCInfo.radioList[a].cityname,
							districtname: valetCInfo.radioList[a].districtname,
							addr: valetCInfo.radioList[a].addrcopy,
							address: valetCInfo.radioList[a].addrcopy,
							street: addr1,
							detailAddr: addr2,
							tel: valetCInfo.radioList[a].tel,
							addressid: valetCInfo.radioList[a].id
						}
						this.save(address, false)
					}
				}
			}
		},
		save (address, saveAddrFlag) {
			let uploadInfo = []
			let valetCInfo = this.$refs.topPart
			let MainTable = this.$refs.midPart
			let memoInfo = this.$refs.bottomPart
			memoInfo.showSrc.forEach(e => {
				let img = {
					sourcepath: e.imgurl,
					extension: e.imgurl.split('.')[e.imgurl.split('.').length - 1]
				}
				uploadInfo.push(img)
			})
			let totalquantity = 0
			let minbuyArr = []
			let zeroArr = []
			for (let i = 0; i < MainTable.tableData.length; i++) {
				let e = MainTable.tableData[i]
				if (e.commpressflag) {
					e.url = e.url.replace('_big', '')
				}
				if (+e.itemquantity === 0) {
					zeroArr.push(e.productname)
				}
				if (+e.itemquantity > e.inventory || e.inventory === 0) {
					minbuyArr.push(e.productname)
				}
				e.pname = e.productname
				e.imgurl = e.url
				e.pmatchid = e.matchid
				e.unit_matchid = e.unitmatchid
				e.p_freighttype = e.freighttype
				e.itemmoney = e.giftflag === 1 ? '0.00' : e.itemmoney
				if (e.speprice) {
					e.private_price = e.giftflag === 1 ? '0.00' : e.speprice
				} else {
					e.public_price = e.giftflag === 1 ? '0.00' : e.customPrice
				}
				if (e.unitType === 0) {
					e.basePrice = e.realPrice
				}
				totalquantity += +e.itemquantity
			}
			if (zeroArr.length !== 0) {
				this.$message.error('［' + zeroArr.join(',') + '］订货数量不能为0！')
				return false
			}
			let data = {
				saveAddrFlag: saveAddrFlag,
				wantarrivaldate: memoInfo.wantarrivaldate,
				createOrderDate: memoInfo.createOrderDate,
				preparedate: memoInfo.preparedate,
				shopid: this.shopId,
				userid: valetCInfo.value,
				username: valetCInfo.userName,
				syscode: valetCInfo.syscode,
				buyersyscodeid: valetCInfo.buyersyscodeid,
				totalquantity: totalquantity,
				totalprice: MainTable.goodsMoney,
				address: address,
				freight: MainTable.freightCheck ? '' : MainTable.freight,
				goodsData: MainTable.tableData,
				paymode: MainTable.isOffLine ? 0 : MainTable.isAdvance ? 4 : null,
				memo: memoInfo.textarea,
				uploadInfos: uploadInfo,
				refundOrderid: this.dataObj.refundOrderId,
				checkPriceFlag: this.checkPriceFlag,
				customerId: valetCInfo.customerid,
				orderid: this.id,
				orderNumber: this.orderNumber
			}
			let msg = valetCInfo.getMsg()
			let product = MainTable.getMsg()
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/replacorder/add`,
				data: data
			}).then(res => {
				if (res.result) {
					let logger = this.$fxLogger.createInfo('order.valet_order.add', { msg: '订单编号：' + res.data + msg + product })
					let updateInfo = this.$fxLogger.updateInfoStart(logger)
					if (logger.loggerSubjoin) {
						updateInfo.success(logger.loggerSubjoin, res)
					} else {
						updateInfo.success()
					}
					if (!MainTable.isOffLine && !MainTable.isAdvance && !MainTable.customData.canpaylaterflag) {
						this.$message.success('订单已提交！请联系您的客户及时付款，' + this.unpaidInvalidTime + '小时内若未付款，订单将自动关闭')
					} else {
						this.$message.success('订单提交成功！')
					}
					this.$router.push('/main/batchValet')
				} else if (res.code === 1000) {
					this.tipId = res.data.id
					this.tipData = res.data.name
					this.tipModal = true
				} else if (res.code === 4009) {
					res.data.forEach(e => {
						e.money = this.$fxUtils.toFixedSHW(e.money, 2)
					})
					this.detailData = res.data
					this.advanceModal = true
				} else if (res.code === 2026) {
					res.data.forEach(e => {
						e.amount = this.$fxUtils.toFixedSHW(e.amount, 2)
					})
					this.detailData2 = res.data
					this.advanceModal2 = true
				} else if (res.code === 4008) {
					this.$message.error('您的预付货款余额不足，请充值或选择其他支付方式')
				} else {
					this.tipId = []
					this.checkPriceFlag = 1
					this.$message.error(res.msg)
				}
			})
			// }
		},
		noSubmit () {
			let MainTable = this.$refs.midPart
			MainTable.tableData.forEach(e => {
				e.isRed = this.tipId.indexOf(e) === -1
			})
			this.tipModal = false
		},
		submitAgain () {
			this.checkPriceFlag = 0
			this.submit()
		},
		findShopList () {
			return new Promise((resolve, reject) => {
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIVShop}/findshoplist`
				}).then(res => {
					if (res.result) {
						resolve(res.data.shop)
					} else {
						this.$message.error(res.msg)
					}
				}).catch(err => {
					this.$message.error(err.msg)
				})
			})
		}
	}
}
</script>

<style lang="stylus" scoped>
.order-body {
	flex: 1
	display flex
	flex-direction column
	.shop-position {
		display flex
		align-items: center
		height: 50px
		font-size: 14px
		border-bottom: 1px solid #dce1fe
		img {
			display inline-block
			width: 20px
			height: 22px
			margin-right: 10px
		}
	}
	.icon-copy {
		color: var(--fx-primary-color);
		margin-left: 5px;
		cursor: pointer
	}
	.order-menu {
		height: 50px
		line-height: 50px
		text-indent: 30px
		text-align: left
		font-size: 15px
		border-bottom: 1px solid #dce1fe
		box-sizing: border-box
	}
	.valet-content-body {
		height: 100%;
		overflow-y: auto;
	}
	.valet-foot {
        height :40px;
        margin-bottom :10px;
        .btn{
            width :130px;
			height :35px;
			margin: 0 30px
        }
	}
	.dialog-title1 {
		text-align: left
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			.el-icon-close{
				color:#fff
			}
		}
	}
}
</style>
<style lang="stylus">
.dialog-title1 {
	.el-dialog__body {
		padding-top: 20px
		max-height: 550px;
		overflow-y: auto;
	}
}
.dialog-title2 {
	text-align: left;
	.el-dialog__footer {
		text-align: center
	}
}
.dialog-title3 {
	text-align: left;
	.el-dialog__body {
		padding: 10px 20px;
	}
}
</style>
